<template>
    <svg
        :width="width"
        :height="height"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="color"
    >
        <!-- THIN -->
        <path
            v-if="weight === 'THIN'"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.07564 7.17574C3.30995 6.94142 3.68985 6.94142 3.92417 7.17574L11.9999 15.2515L20.0756 7.17574C20.31 6.94142 20.6899 6.94142 20.9242 7.17574C21.1585 7.41005 21.1585 7.78995 20.9242 8.02426L12.4242 16.5243C12.1899 16.7586 11.81 16.7586 11.5756 16.5243L3.07564 8.02426C2.84132 7.78995 2.84132 7.41005 3.07564 7.17574Z"
            fill="currentColor"
        />

        <!-- REGULAR -->
        <path
            v-else-if="weight === 'REGULAR'"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.93427 7.43451C3.24669 7.12209 3.75322 7.12209 4.06564 7.43451L12 15.3688L19.9343 7.43451C20.2467 7.12209 20.7532 7.12209 21.0656 7.43451C21.3781 7.74693 21.3781 8.25346 21.0656 8.56588L12.5656 17.0659C12.2532 17.3783 11.7467 17.3783 11.4343 17.0659L2.93427 8.56588C2.62185 8.25346 2.62185 7.74693 2.93427 7.43451Z"
            fill="currentColor"
        />

        <!-- FILL -->
        <path
            v-else
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.79289 7.29289C3.18342 6.90237 3.81658 6.90237 4.20711 7.29289L12 15.0858L19.7929 7.29289C20.1834 6.90237 20.8166 6.90237 21.2071 7.29289C21.5976 7.68342 21.5976 8.31658 21.2071 8.70711L12.7071 17.2071C12.3166 17.5976 11.6834 17.5976 11.2929 17.2071L2.79289 8.70711C2.40237 8.31658 2.40237 7.68342 2.79289 7.29289Z"
            fill="currentColor"
        />
    </svg>
</template>

<script>
    export default {
        name: 'expand-more-icon',
        props: {
            width: {
                type: [String, Number],
                default: 24,
            },
            height: {
                type: [String, Number],
                default: 24,
            },
            color: {
                type: String,
                default: 'text-black',
            },
            weight: {
                type: String,
                default: 'THIN',
                validator: (val) => ['THIN', 'REGULAR', 'FILL'].includes(val),
            },
        },
    };
</script>
